module.exports = __webpack_public_path__ + "static/media/23.88623c88.png";